import React from "react";
import { Draggable, Droppable, DraggableProvided, DroppableProvided } from "react-beautiful-dnd";
import Title from "../Title";
import Card from "../Card";
import InputContainer from "../InputContainer";

import "./styles.scss";
import { ITask } from "../../types/Task";

type ListProps = {
  id: string;
  title: string;
  cards: ITask[];
}


export default function List({ list, index }: { list: ListProps, index: number }) {
  return (
    <Draggable draggableId={list.id} index={index}>
      {(provided: DraggableProvided) => (
        <div {...provided.draggableProps} ref={provided.innerRef}>
          <div className="list-cards" {...provided.dragHandleProps}>
            <div className="title-list">
              <Title title={list.title} listId={list.id} totalCards={list.cards.length} />
            </div>
            <div className="container-cards">
              <Droppable droppableId={list.id} type="task">
                {(provided: DroppableProvided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="card-container"
                  >
                    {list.cards.map((card, index) => (
                      <Card
                        key={card.id}
                        card={card}
                        index={index}
                        listId={list.id}
                      />
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
            <InputContainer listId={list.id} type="card" />
          </div>
        </div>
      )}
    </Draggable>
  );
}
